<template>
  <v-select
    :disabled="disabled"
    :items="ortofotos"
    v-model="ortofoto"
    item-text="name"
    prepend-inner-icon="photo"
    append-icon="keyboard_arrow_down" 
    persistent-hint
    :hint="$t('selecciona.ortofoto')"
  ></v-select>
</template>


<script>
import SourceTileWMS from 'ol/source/tilewms'

/**
 * Componente para seleccionar ortofoto como mapa base
 */
export default {
  props: ['disabled', 'map', 'ortoLayer'],

  data() {
    return {
      ortofoto: null
    }
  },

  computed: {
    ortofotos() {
      if(!this.map) return []

      return this.map
        .getLayers()
        .getArray()
        .find(l => l.getProperties().id == 'group-ortofotos')
        .getLayers()
        .getArray()
        .map(l => ({
          name: l.getSource().getParams().layers, 
          url: l.getSource().getUrls()[0],
          attributions: l.getSource().getAttributions() })
        )
        .reverse()
    },
  },

  watch: {
    ortofotos() {
      this.ortofoto = this.ortofotos[0]
    },

    ortofoto({name: layers, url, attributions}) {
      
      const source = new SourceTileWMS({ url, params: { layers }, attributions, crossOrigin: 'anonymous' })
      this.ortoLayer.setSource(source)
    },
  }
}
</script>



// WEBPACK FOOTER //
// select-ortofoto.vue?46a45938